import React from "react";
import { Card } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { LockOutlined } from "@ant-design/icons";

const CardCoverImage = (title) => {
  switch (title) {
    case "Performance":
      return "/NavCardImages/performance_cover.svg";
    case "Navigator":
      return "/NavCardImages/navigator_cover.svg";
    case "Influencer":
      return "/NavCardImages/influencer_cover.svg";
    case "Legacy":
      return "/NavCardImages/legacy_cover.svg";
    case "Bulk Uploader":
      return "/NavCardImages/bulk_uploader_cover.svg";
    case "SEO":
      return "/NavCardImages/seo_cover.svg";
    default:
      return "/NavCardImages/performance_cover.svg";
  }
};

const HomePageNavCard = ({
  redirectUrl = "/",
  title = "Performance",
  description = "Short description",
  isDisabled = false,
}) => {
  const navigate = useNavigate();
  const handleClick = () => {
    if (!isDisabled) {
      navigate(redirectUrl);
    }
  };

  return (
    <div className="home-page-nav-card" onClick={handleClick}>
      {isDisabled && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "var(--disabled-overlay-color)",
            zIndex: 10,
            borderRadius: "var(--co-radius) var(--co-radius) 64px var(--co-radius)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <LockOutlined
            className="soft-shadow"
            style={{ color: "var(--green-color)", fontSize: "2rem" }}
          />
        </div>
      )}

      <Card
        hoverable
        style={{
          width: "100%",
          minWidth: "280px",
          overflow: "hidden",
          height: "260px",
          backgroundColor: "var(--dark-grey-color)",
          // make the hover effect none
          boxShadow: "0.89px 21.3px 51px 0 rgba(0, 0, 0, 0.53)",
          border: "0",
          borderBottomRightRadius: "64px",
        }}
        cover={
          <img
            alt="example"
            src={CardCoverImage(title)}
            style={{
              width: "100%",
              height: "111px",
              objectFit: "cover",
            }}
          />
        }
      >
        <h2 style={{ color: "var(--white-color)", marginBottom: "0.1em" }}>
          {title}
        </h2>
        <p
          style={{
            color: "var(--white-color)",
            maxWidth: "23vw",
            minWidth: "190px",
            fontSize: "0.70em",
            marginTop: "0.1em",
          }}
        >
          {description}
        </p>
        <ArrowRightOutlined
          style={{
            color: "var(--white-color)",
            fontSize: "1.5rem",
          }}
        />
      </Card>
    </div>
  );
};

export default HomePageNavCard;
